export enum EXPERT_TAB {
  EXPERT = 'EXPERT',
  TRAINING = 'TRAINING',
  TOOLS = 'TOOLS',
  WIDGET = 'WIDGET',
  SPEECH = 'SPEECH',
  INTEGRATIONS = 'INTEGRATIONS',
  CHAT = 'CHAT',
  HISTORY = 'HISTORY',
}
